const id = {
  login: {
    title: "Sistem Pengiriman Data",
    email: "Surel",
    password: "Kata Sandi",
    forgotPassword: "Lupa kata sandi?",
    logout: "Keluar",
    inEmail: "Surel tidak valid",
    loginfailed: "Gagal masuk, surel atau kata sandi salah",
    enterEmail: "Silakan masukkan surel",
    enterPassword: "Silakan masukkan kata sandi",
    enterCode: "Silakan masukkan kode verifikasi",
    passwordNotMatch: "Kata sandi tidak cocok",
  },
  forgot: {
    forgotPassword: "Lupa Kata Sandi",
    tip: "Kami akan mengirimkan kode verifikasi ke surel Anda",
    email: "Surel",
    code: "Kode Verifikasi",
    password: "Kata Sandi",
    confirmPassword: "Konfirmasi Kata Sandi",
    send: "Kirim",
    submit: "Kirim",
    login: "Masuk",
  },
  menu: {
    mange: "Kelola Formulir",
    mangeTip: "Buat formulir data dan lihat data",
    submission: "Isi Formulir",
    account: "Kelola Akun",
    uwell: "Akun Internal",
    external: "Akun Eksternal",
  },
  editList: {
    fill: "Isi",
    record: "Catatan Data",
    createdTime: "Waktu Pembuatan",
    formTitle: "Judul Formulir",
    titleTip: "Silakan masukkan judul",
    showInput: "Tampilkan formulir yang diisi dan catatan pengisian",
  },
  editFill: {
    save:'simpan',
    nosave:'Jangan menyimpan',
    backSaveTip:'Apakah Anda ingin menyimpan konten yang telah diisi?',
    submitted:'telah dikirim',
    notsubmitted:'belum dikirim',

    submit: "Kirim",
    submitSuccess: "Berhasil dikirim",
    fillAgain: "Isi lagi",
    invalid: "Parameter tidak valid",
    noTime: "Tidak dapat menggunakan formulir saat ini",
    failedStop: "Gagal mengirimkan, formulir tidak menerima lebih banyak data",
    failedNot: "Gagal mengirimkan, formulir tidak ditemukan",
    failedPassed: "Gagal mengirimkan, formulir hanya dapat diisi sekali",
    failedOnce:
      "Gagal mengirimkan, formulir hanya dapat diisi sekali dalam sehari",
    noempty: "Tidak boleh ada bidang input yang kosong",
  },
  editInfo: {
    SubmitTime: "Waktu Pengiriman",
    submitter:'Pengirim',
    search: "Cari",
    clear: "Bersihkan",
    filter: "Filter",
    fieldSetting: "Pengaturan Kolom",
    export: "Ekspor",
    createBy: "Dibuat oleh",
    updateTime: "Waktu Pembaruan",
    status:'status',
    action: "Aksi",
    detail: "Detail",
    edit: "Ubah",
    more:"Lagi",
    copy:"Menyalin",
    startDate: "Tanggal Mulai",
    endDate: "Tanggal Selesai",
    selectAll: "Pilih Semua",
    confirm: "Konfirmasi",
    cancel: "Batal",
    addFilter: "Tambahkan Filter",
    pleaseSelect: "Silakan pilih",
    pleaseFillIn: "Silakan isi data",
    delete: "Hapus",
    filterIncom: "Filter di baris {num} tidak lengkap, harap periksa",
    noData: "Tidak ada data",
    uploadfailed: "Gagal mengunggah",
    total: "Total: {num} catatan",
    deleteTip: 'Questa operazione eliminerà i dati. Vuoi continuare?',
    deleteSuccess: 'Eliminazione riuscita'
  },
  fillIn: {
    equal: "Sama dengan",
    noequal: "Tidak sama dengan",
    contains: "Mengandung",
    notcontains: "Tidak mengandung",
    empty: "Kosong",
    notempty: "Tidak kosong",
    before: "Sebelum",
    after: "Setelah",
    greaterequal: "Lebih besar atau sama dengan",
    lessequal: "Lebih kecil atau sama dengan",
    greaterthan: "Lebih besar dari",
    lessthan: "Lebih kecil dari",
  },
  editEye: {
    detail: "Data Formulir",
  },
  editUpdate: {
    editForm: "Ubah Formulir",
    returnList: "Kembali ke Daftar",
  },
};

export default id;
